import React from "react";
// npm install --save @mui/material @emotion/react @emotion/styled @mui/icons-material @hello-pangea/dnd
import {
    Drawer,
    Box,
    TextField,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Typography,
    Stepper,
    Step,
    StepLabel,
    StepIconProps,
    Divider,
    Paper,
    IconButton,
    LinearProgress,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import ListAltIcon from "@mui/icons-material/ListAlt";
import InfoIcon from "@mui/icons-material/Info";


import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

const stepsLabels = [
    { label: "Informations", icon: <InfoIcon /> },
    { label: "Ingrédients", icon: <RestaurantIcon /> },
    { label: "Étapes", icon: <ListAltIcon /> },
    { label: "Résumé", icon: <CheckCircleIcon /> }
];

const ColorConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        borderRadius: 1,
        backgroundColor: theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.2)"
            : "rgba(0,0,0,0.2)",
        transition: "all 0.4s ease"
    },
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
        backgroundColor: "#6fb8af",
        height: 4
    },
    [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
        backgroundColor: "#6fb8af",
        height: 4
    }
}));


export default function RecipeDrawer({
                                         drawerOpen,
                                         setDrawerOpen,
                                         form,
                                         setForm,
                                         steps,
                                         addStep,
                                         updateStep,
                                         removeStep,
                                         onDragEnd,
                                         handleSubmit
                                     }) {
    const [activeStep, setActiveStep] = React.useState(0);

    const next = () => setActiveStep((prev) => prev + 1);
    const back = () => setActiveStep((prev) => prev - 1);

    const isStepValid = (step) => {
        switch (step) {
            case 0: // Informations
                return (form.titre ?? "").trim().length > 0 &&
                    (form.image ?? "").trim().length > 0 && (form.temps ?? "").trim().length > 0 && (form.difficulte ?? "").trim().length > 0 && (form.viande ?? "").trim().length > 0;

            case 1: // Ingrédients
                return (form.ingredients ?? "").trim().length > 0;

            case 2: // Étapes
                return steps.length > 0 &&
                    steps.every(s => (s.texte ?? "").trim().length > 0 && (s.image ?? "").trim().length > 0);

            case 3: // Résumé
                return true;

            default:
                return false;
        }
    };



    return (
        <Drawer
            anchor="right"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            PaperProps={{
                sx: {
                    width: "55vw",
                    p: 3,
                    display: "flex",
                    flexDirection: "column"
                }
            }}
        >
            {/* HEADER */}
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                Ajouter une recette
            </Typography>

            {/* STEPPER */}
                <Stepper
                    activeStep={activeStep}
                    alternativeLabel
                    connector={<ColorConnector />}
                    sx={{
                        mb: 3,
                        /* LABEL ACTIVE */
                        "& .MuiStepLabel-label.Mui-active": {
                            color: "#6fb8af",
                            fontWeight: 700,
                            backgroundColor: "rgba(111,184,175,0.18)",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            transition: "all 0.2s ease"
                        },

                        /* LABEL COMPLETED */
                        "& .MuiStepLabel-label.Mui-completed": {
                            color: "#6fb8af",
                            fontWeight: 600,
                            backgroundColor: "rgba(111,184,175,0.10)",
                            padding: "4px 8px",
                            borderRadius: "6px"
                        },

                        /* ICÔNE ACTIVE */
                        "& .MuiStepIcon-root.Mui-active": {
                            color: "#6fb8af",
                            borderRadius: "50%",
                            border: "2px solid #6fb8af",
                            backgroundColor: "rgba(111,184,175,0.18)",
                            transition: "all 0.2s ease"
                        },

                        /* ICÔNE COMPLETED */
                        "& .MuiStepIcon-root.Mui-completed": {
                            color: "#6fb8af",
                            borderRadius: "50%",
                            border: "2px solid #6fb8af",
                            backgroundColor: "rgba(111,184,175,0.10)"
                        }
                    }}
                >


                    {stepsLabels.map((step, index) => (
                    <Step key={index}>
                        <StepLabel icon={step.icon}>{step.label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

                <LinearProgress
                    variant="determinate"
                    value={(activeStep / (stepsLabels.length - 1)) * 100}
                    sx={{
                        height: 8,
                        borderRadius: 5,
                        mb: 3,
                        "& .MuiLinearProgress-bar": {
                            backgroundColor: "#6fb8af",
                            transition: "all 0.4s ease"
                        },
                        backgroundColor: "rgba(111,184,175,0.15)"
                    }}
                />

            <Divider sx={{ mb: 2 }} />

            {/* CONTENU */}
            <Box sx={{ flex: 1, overflowY: "auto", pr: 1 }}>
                {/* ÉTAPE 1 — INFOS */}
                {activeStep === 0 && (
                    <>
                        <TextField
                            fullWidth
                            label="Titre de la recette"
                            sx={{ mb: 2 }}
                            value={form.titre}
                            onChange={(e) => setForm({ ...form, titre: e.target.value })}
                        />

                        <TextField
                            fullWidth
                            label="URL de l'image principale"
                            sx={{ mb: 2 }}
                            value={form.image}
                            onChange={(e) => setForm({ ...form, image: e.target.value })}
                        />

                        <TextField
                            fullWidth
                            label="Temps de préparation"
                            placeholder="ex: 25 min"
                            sx={{ mb: 2 }}
                            value={form.temps}
                            onChange={(e) => setForm({ ...form, temps: e.target.value })}
                        />

                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel>Difficulté</InputLabel>
                            <Select
                                value={form.difficulte}
                                label="Difficulté"
                                onChange={(e) => setForm({ ...form, difficulte: e.target.value })}
                            >
                                <MenuItem value="Facile">Facile</MenuItem>
                                <MenuItem value="Moyen">Moyen</MenuItem>
                                <MenuItem value="Difficile">Difficile</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel>Type de viande</InputLabel>
                            <Select
                                value={form.viande}
                                label="Type de viande"
                                onChange={(e) => setForm({ ...form, viande: e.target.value })}
                            >
                                <MenuItem value="Poulet">Poulet</MenuItem>
                                <MenuItem value="Bœuf">Bœuf</MenuItem>
                                <MenuItem value="Porc">Porc</MenuItem>
                                <MenuItem value="Poisson">Poisson</MenuItem>
                                <MenuItem value="Végétarien">Végétarien</MenuItem>
                                <MenuItem value="Vegan">Vegan</MenuItem>
                            </Select>
                        </FormControl>
                    </>
                )}

                {/* ÉTAPE 2 — INGREDIENTS */}
                {activeStep === 1 && (
                    <TextField
                        fullWidth
                        multiline
                        minRows={6}
                        label="Ingrédients (un par ligne)"
                        sx={{ mb: 2 }}
                        value={form.ingredients}
                        onChange={(e) => setForm({ ...form, ingredients: e.target.value })}
                    />
                )}

                {/* ÉTAPE 3 — ÉTAPES */}
                {activeStep === 2 && (
                    <>
                        <Button variant="contained" sx={{ mb: 2 }} onClick={addStep}>
                            + Ajouter une étape
                        </Button>

                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="steps">
                                {(provided) => (
                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                        {steps.map((step, index) => (
                                            <Draggable key={step.id} draggableId={step.id.toString()} index={index}>
                                                {(provided) => (
                                                    <Paper
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        sx={{
                                                            p: 2,
                                                            mb: 2,
                                                            display: "flex",
                                                            gap: 2
                                                        }}
                                                    >
                                                        <div {...provided.dragHandleProps}>
                                                            <DragIndicatorIcon sx={{ cursor: "grab", mt: 1 }} />
                                                        </div>

                                                        <Box sx={{ flex: 1 }}>
                                                            <TextField
                                                                fullWidth
                                                                label="URL de l'image"
                                                                sx={{ mb: 2 }}
                                                                value={step.image}
                                                                onChange={(e) =>
                                                                    updateStep(step.id, "image", e.target.value)
                                                                }
                                                            />

                                                            <TextField
                                                                fullWidth
                                                                multiline
                                                                minRows={3}
                                                                label="Tâches (une par ligne)"
                                                                sx={{ mb: 2 }}
                                                                value={step.texte}
                                                                onChange={(e) =>
                                                                    updateStep(step.id, "texte", e.target.value)
                                                                }
                                                            />

                                                            <TextField
                                                                fullWidth
                                                                multiline
                                                                minRows={2}
                                                                label="L'astuce du chef (optionnel)"
                                                                value={step.astuce || ""}
                                                                onChange={(e) =>
                                                                    updateStep(step.id, "astuce", e.target.value)
                                                                }
                                                            />
                                                        </Box>

                                                        <IconButton color="error" onClick={() => removeStep(step.id)} sx={{
                                                            width: 40,
                                                            height: 40,
                                                            alignSelf: "flex-start"
                                                        }}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Paper>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </>
                )}

                {/* ÉTAPE 4 — RÉSUMÉ */}
                {activeStep === 3 && (
                    // <Box >
                    //     <Typography variant="h6" sx={{ mb: 2 }}>
                    //         Résumé
                    //     </Typography>
                    //
                    //     <pre style={{ background: "#f5f5f5", padding: 16, borderRadius: 8 }}>
                    //         {JSON.stringify({ form, steps }, null, 2)}
                    //     </pre>
                    // </Box>
                    <Box
                        sx={{
                            p: 3,
                            borderRadius: 2,
                            backgroundColor: "rgba(111,184,175,0.10)", // léger vert pastel
                            color: "text.primary",
                            border: "1px solid rgba(111,184,175,0.25)",
                            boxShadow: 1
                        }}
                    >
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Résumé de la recette
                        </Typography>

                        <Typography><strong>Nom :</strong> {form.titre}</Typography>
                        <Typography><strong>Temps de préparation :</strong> {form.temps}</Typography>
                        <Typography><strong>difficulté :</strong> {form.difficulte}</Typography>
                        <Typography><strong>Viande :</strong> {form.viande}</Typography>
                        <Typography><strong>Ingrédients :</strong></Typography>

                        <ul>
                            {form.ingredients
                                ?.split("\n")
                                .map(i => i.trim())
                                .filter(i => i.length > 0)
                                .map((ing, i) => (
                                    <li key={i}>{ing}</li>
                                ))
                            }
                        </ul>

                        <Typography><strong>Étapes :</strong></Typography>
                        <ol style={{ paddingLeft: "20px" }}>
                            {steps.map((step, index) => (
                                <li key={index} style={{marginBottom: "16px"}}>
                                    {step.texte
                                        ?.split("\n")
                                        .map(line => line.trim())
                                        .filter(line => line.length > 0)
                                        .map((line, i) => (
                                            <Typography key={i} sx={{color: "text.primary", ml: 1}}>
                                                {line}
                                            </Typography>
                                        ))
                                    }

                                    {step.astuce && (
                                        <Typography sx={{fontStyle: "italic", opacity: 0.7, mt: 1}}>
                                            💡 Astuce : {step.astuce}
                                        </Typography>
                                    )}
                                </li>
                            ))}
                        </ol>


                    </Box>

                )}
            </Box>

            {/* FOOTER */}
            <Divider sx={{mt: 2}}/>

            <Box sx={{display: "flex", gap: 2, mt: 2}}>
                {activeStep > 0 && (
                    <Button variant="outlined" fullWidth onClick={back}>
                        Retour
                    </Button>
                )}

                {activeStep < 3 && (
                    <Button variant="contained" fullWidth onClick={next} disabled={!isStepValid(activeStep)}>
                        Suivant
                    </Button>
                )}

                {activeStep === 3 && (
                    <Button variant="contained" color="success" fullWidth onClick={handleSubmit}>
                        Enregistrer
                    </Button>
                )}
            </Box>
        </Drawer>
    );
}
